const content = document.querySelector('.custom-section-tabbed-content .row');
  const wrapper = document.getElementById('tabbed-content-wrapper');

  if (content && wrapper) {
    wrapper.innerHTML = content.outerHTML;
  }


 // Select all anchor links that have a hash href
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        links.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: "smooth"
          });
        }
      });
    });